import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Yli +100 asiakasta on jo tilannut meiltä turvallisesti',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Yli +1 000 asiakasta on jo tilannut meiltä turvallisesti',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Yli +10 000 asiakasta on jo tilannut meiltä turvallisesti',
  },
};
